


































import Vue from 'vue'
import SpiralPath from './SpiralPath.vue'

export default Vue.extend({
  name: 'SpiralText',
  components: {
    SpiralPath
  },
  data: function () {
    return {
      pathIdPrefix: 'path'
    }
  },
  props: {
    size: { type: Number, required: false, default: 16 },
    fontSize: { type: Number, required: false, default: 12 },
    lineHeight: { type: Number, required: false, default: 1.0 },
    text: { type: String, required: false, default: '' },
    strokeWidth: { type: Number, required: false, default: 0 },
    inToOut: { ype: Boolean, required: false, default: false },
    counterclockwise: { ype: Boolean, required: false, default: false },
    startFromInner: { ype: Boolean, required: false, default: false },
    initAngle: { type: Number, required: false, default: 0 },
    paddingInner: { type: Number, required: false }
  },
  computed: {
    halfSize (): number {
      return this.size / 2
    },
    translate (): string {
      return `translate(${this.halfSize} ${this.halfSize})`
    },
    paddingInnerComputed (): number {
      return this.paddingInner === undefined
      ? this.counterclockwise
        ? this.fontSize
        : 0
      : this.paddingInner
    }
  }
})




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SpiralText.vue